import React from 'react';
import { UnfoldMore, KeyboardArrowUp, KeyboardArrowDown } from '@mui/icons-material';

/**
 * Utility function to get the appropriate sort icon based on current sort state
 * Returns different Material-UI icons based on whether column is sorted and direction
 * 
 * @param sortBy - Currently sorted column identifier
 * @param sortOrder - Current sort direction ('ASC' or 'DESC')
 * @param column - Column identifier to check against current sort
 * @returns React node containing the appropriate sort icon
 */
export const getSortIcon = (sortBy: string, sortOrder: 'ASC' | 'DESC', column: string): React.ReactNode => {
  if (sortBy !== column) return <UnfoldMore />;
  return sortOrder === 'ASC' ? <KeyboardArrowUp /> : <KeyboardArrowDown />;
};
